<template>
  <div class="my_issue_topic" >
    <div class="list_wrap">
      <List v-model="loading" :finished="finished" @load="loadMore" finished-text="It's the end~"> 
        <div class="item" v-for="(item,index) in list" :key="index">
          <div class="item_top">
            <div class="logo">
              <img :src="item.matedata.From.AvatarUrl" v-if="item.matedata.From.AvatarUrl" v-load="'oAvatar'"/>
              <img src="@assets/img/empty.png"  v-else>
            </div>
            <div class="details">
              <div class="line">
                <span class="name">{{item.matedata.From.Name}}</span>
                <span class="job">{{item.matedata.From.JobTitle}}</span>
              </div>
              <div class="info2">{{item.matedata.From.CompName}}</div>
            </div>
          </div>

          <div class="item_center">
            {{item.content}}
          </div>
          
          <div class="item_bottom">
            <span>{{item.matedata.To.Name}}回复：</span>
            {{item.toContent}}
          </div>
          
        </div>
        <div slot="loading" class="f-tac loading">
          <img src="@assets/img/new/icon-loading.png" />
          loading...
        </div>
        <div slot="finished" class="f-tac loading">It's the end~</div>
      </List>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import moment from "moment";
import { List } from "vant";
import { mapGetters, mapActions } from "vuex";
export default {  
  name: "my-issue-topic",
  data() {
    return {
      loading: false,   //联系我的加载状态
      finished: false,  //联系我的是否完成状态
      list: [],         //联系我的列表
      pageIndex: 0,
      pageSize:20,
      querySayHello:'',
    };
  },
  components: { List },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId:"getExhibitionId"
    }),
    MemberGql(){
        return gql `query
                querySayHello($query: QueryInput!){
                    querySayHello(query:$query){
                       hasNextPage
                       pageIndex
                       totalCount
                       items{
                        content
                        createAt
                        exhibitionId
                        exhibitorId
                        fromId
                        id
                        matedata
                        sayTypes
                        toClickCount
                        toId
                        typeIds
                        toContent
                        toState
                       }
                    }
                }`
      },
  },
  created() {
  },
  methods: {
    ...mapActions({
      delTalk:'my/delTalk',
      LinkHotPub:'linkTo/LinkHotPub',
      LinkToHotTopDetails:'linkTo/LinkToHotTopDetails'
    }),
    wCount(value) {
      //过万处理
      let num = value;
      if (value > 9999) {
        //大于9999显示x.xx万
        num = Math.floor(value / 100) / 100 + "w";
      } else {
        num = value;
      }
      return num;
    },
    getList(){
      let where={
        "Equal":{
          "n":"exhibitionId",
          "v":this.exhibitionId
        },
        "EqualB":{
          "n":"toState",
          "v":1  // 已回应
        },
        "Equal2":{
            "n":"fromId",
            "v":this.userInfo.inMember.id
        },
      }
      let order=[
        {
          "N":"createAt",
          "v":0
        }
      ]
      let opt={
        page:this.pageIndex,
        size:this.pageSize,
        where:JSON.stringify(where),
        order:JSON.stringify(order)
      }
      this.$apollo.addSmartQuery("querySayHello",{ 
        query:this.MemberGql,
        variables:{
         query:opt
        },
        fetchPolicy: 'network-only',    //清理缓存
        result(res){
           let data = JSON.parse(JSON.stringify(res));
           console.log(data,'----')
           if(data&&data.data.querySayHello){
                let currentList = data.data.querySayHello.items;
                currentList.map(c=>{
                if(c.matedata){
                    c.matedata = JSON.parse(c.matedata);
                }
                })
                if(this.pageIndex == 1){
                this.list = currentList;
                } else {
                this.list = [...this.list,...currentList]
                }
                this.loading = false;
                if (!data.data.querySayHello.hasNextPage) {
                this.finished = true;
                }
            }
        },
        error(err){
          this.loading=false;
          this.finished = true;
          console.log('err',err)
        }
      })
    },
    loadMore(){
      if(this.finished) return;
      this.pageIndex+=1;
      this.getList();
    },
    //删除
    async delStateNoTalk(id){
      let res= await this.delTalk(id);
      if(res.result){
        this.list=this.list.filter(item => item.id!=id);
        this.$toast.success("删除成功");
      }else{
        this.$toast.fail('删除失败')
      }
    },
    //重新编辑
    topicEdit(item){
      let imgArr=[];
      if(item.imgUrls&&item.imgUrls.length){
        item.imgUrls.map(e=>{
          imgArr.push({url:e})    
        })
      }
      localStorage.setItem("content",item.content);
      localStorage.setItem("relepase",JSON.stringify(item.themes));
      if(imgArr.length){
        localStorage.setItem("Upimg",JSON.stringify(imgArr));
      }
      this.LinkHotPub({id:false,talkId:item.id})
    },
  }
};
</script>

<style scoped lang="scss">
//展品列表
.my_issue_topic{
  .list_wrap{
    .item{
      background-color: #fff;
      margin-bottom: 0.3rem;
      box-shadow: 0 0  0.1rem 0
      rgba(0, 0, 0, 0.1);
      border-radius: 0.1rem;
      padding:0.2rem;
      margin-bottom: 0.3rem;
      &:last-child{
        margin-bottom: 0;
      }
      .item_top {
        color: #333;
        display: flex;
        .logo {
          position: relative;
          width: 0.88rem;
          height: 0.88rem;
          margin-right: 0.14rem;
          img {
            border-radius: 50%;
            width: 100%;
            height: 100%;
            // object-fit: cover;
          }
        }
        .details {
          .line {
            display: flex;
            align-items: flex-end;
            margin-bottom: 0.16rem;
            .name {
              font-size: 0.26rem;
              margin-right: 0.1rem;
              font-weight: 400;
            }
            .job {
              font-size: 0.22rem;
              color: #666;
            }
          }
          .info2 {
            font-size: 0.22rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .txt {
          width: 2rem;
          padding-top: 0.16rem;
          text-align: right;
          font-size: 0.2rem;
          color: #bfbfbf;

          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .create_time{
          margin-left: auto;
          flex-shrink: 0;
          font-size: 0.2rem;
          color: #bfbfbf;
        }
        &-gx{
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        &-b {
          display: flex;
          .cclb {
            &-l {
              font-size: 0.2rem;
              width: 80%;
              padding-top: 0.13rem;
              .txt2 {
                color: #ffcc00;
                width: calc(100% - 1px);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .txt3 {
                width: calc(100% - 1px);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            &-r {
              width: 20%;
              text-align: right;
              .btn {
                height: 0.48rem;
                line-height: 0.48rem;
                display: inline-block;
                padding: 0 0.2rem;
                background-color: #f85b0f;
                border-radius: 0.04rem;
              }
            }
          }
        }
      }
      .item_center{
        font-size: .26rem;
        line-height: .36rem;
        color: #333;
        margin-top: .22rem;
      }
      .item_bottom{
        width: 100%;
        background-color: #f2f2f2;
        font-size: .26rem;
        color: #666;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
        padding:.1rem .16rem;
        margin-top: .24rem;
        line-height: 1.5;
        span{
            display: inline-block;
            color: #1890ff;
            font-size: .26rem;
        }
      }
    }
  }
}
.f-tac {
  text-align: center;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
